import { useNavigate } from "react-router-dom";

const BRAND = "#FF6B35";

interface Props {
  item: {
    id: number;
    item_id?: number;
    title: string;
    name?: string;
    thumb: string;
    short_title?: string;
    status?: number; // 审核状态: 0=待审核, 1=审核通过, 3=审核失败
    check_status?: number; // 兼容字段（同 status）
  };
}

/**
 * 原版 staff-cate-item.vue 行为：
 * - 显示项目缩略图 + 标题 + 简介
 * - 左下角状态标签：check_status === 1 显示"待审核"，=== 3 显示"审核失败"
 * - 点击"修改"按钮 → 导航到详情页
 */
export function StaffCateItem({ item }: Props) {
  const navigate = useNavigate();

  // 统一审核状态
  const checkStatus = item.check_status ?? item.status;

  const handleCheckDetail = () => {
    navigate(`/workspace/edit-item/detail`, { state: { cateId: item.item_id ?? item.id } });
  };

  return (
    <div className="w-full flex items-center py-[15px] border-b border-gray-100/15">
      {/* 缩略图 + 状态标签 */}
      <div className="relative mr-[15px] shrink-0">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={item.thumb || ""}
          alt=""
          className="w-[60px] h-[60px] rounded-xl object-cover bg-gray-100"
        />
        {/* 待审核 / 审核失败 遮罩标签 */}
        {(checkStatus === 1 || checkStatus === 3) && (
          <div className={`absolute bottom-0 left-0 w-full text-center text-xs ${checkStatus !== 3 ? "text-green-500" : "text-red-500"}`}
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            {checkStatus === 1 ? "待审核" : checkStatus === 3 ? "审核失败" : ""}
          </div>
        )}
      </div>

      {/* 信息区 */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-gray-900 truncate">{item.title || item.name}</p>
        {item.short_title && (
          <p className="text-xs text-gray-400 mt-1 line-clamp-2 leading-relaxed">{item.short_title}</p>
        )}
      </div>

      {/* 修改按钮 */}
      <button
        onClick={handleCheckDetail}
        className="ml-[10px] shrink-0 px-2.5 py-1 rounded-[4px] text-xs font-medium cursor-pointer active:scale-[0.98]"
        style={{ background: BRAND, color: "#fff" }}
      >
        修改
      </button>
    </div>
  );
}
